import React from "react";
import { NoteEditModalTemplate } from "themes/application/tracking-case/components";
import { observer } from "mobx-react";
import { NoteEditModalStore } from "application/tracking-case/stores";
import { setCurrentView } from "core/utils";

@setCurrentView((rootStore,componentProps) => new NoteEditModalStore(rootStore,componentProps), "noteEditModalStore")
@observer
class NoteEditModal extends React.Component {
    render() {
        return <NoteEditModalTemplate {...this.props} />;
    }
}

export default NoteEditModal;